module.exports = __webpack_public_path__ + "static/img/gantanhao@2x.fe410d8b.png";